import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, Output, EventEmitter, } from '@angular/core';

import { MysqlService } from './../../../../../services/mysql.service';
import { SubjectNote } from './../../../../../api/subjectNote';
import { SubjectBilling } from './../../../../../api/subjectBilling';
import {DemoService} from '../../../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HotToastService } from '@ngneat/hot-toast';
import { TabsetComponent } from 'ngx-bootstrap';
import { SubjectInvoice } from '../../../../../shared/models/subjectInvoice.model';
import { SubjectInvoiceItem } from '../../../../../shared/models/subjectInvoiceItem.model';
import { SubjectWorkOrder } from '../../../../../shared/models/subjectWorkOrder.model';
import { Brand } from '../../../../../api/brand';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';


@Component({
  selector: 'app-subject-cost',
  templateUrl: './subject-cost.component.html',
  styleUrls: ['./subject-cost.component.css']
})
export class SubjectCostComponent implements OnInit {

  model: SubjectBilling;

  @Input() subject_id: number;
  @Input() job_id: number;
  @Input() file_number: number;

  
  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
// grid other module
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();

//  invoice_model: SubjectInvoice = new SubjectInvoice();
invoice_model: any = SubjectInvoice;
  invoice_item_model: any = SubjectInvoiceItem;

work_order_model: any = SubjectWorkOrder;

  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  brand_id: any;
  subject_notes: Object;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  get_latest_subject_note_id: Object;
  subjects: Object;
  subject_billing: any;
  get_latest_subject_billing_id: any;
  subject: any;
  subject_number: any;
  job_number: any;
  subject_invoices: Object;
  current_invoice_couunt: number;
  subject_progress: Object;
  invoice_status: Object;
  invoice_status_name: any;
  invoice_status_var: any;
  invoice_payment_status: Object;
  invoice_payment_status_name: any;
  invoice_payment_status_var: any;
  invoice_communication_status: Object;
  invoice_communication_status_name: any;
  invoice_communication_status_var: any;
  subject_work_orders: Object;
  current_work_order_couunt: number;
  assignedBrandList: any;
  myob_checker: Object;
  spending: Object;
  spendingModel: Object;


  constructor(
    private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService,
    private gfunc: GlobalFunctionsService
  ) {

    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
// Set loggind in User Value (USER ID)
this.sessionUserId = this.currentUserVAR.user_id;
this.sessionUsername = this.currentUserVAR.username;
this.sessionBrandId = this.currentUserVAR.brand_id;
this.brand_id = this.sessionBrandId;

   }

  ngOnInit() {
    this.model = new SubjectBilling();
    this.getSubjectBilling(this.subject_id);
    this.model.job_id = this.job_id;
    this.model.subject_id = this.subject_id;
    this.getJobSubject(this.subject_id);
   // this.getSubjectInvoices(this.subject_id);
   this.getSubjectAgentBrandsAssigned(this.subject_id);
    this.getSubjectWorkOrders(this.subject_id);

  
  }

  getSubjectBilling(subject_id) {
    this._demoService.getSubjectBilling(subject_id).subscribe(
      data => { this.subject_billing = data;
       // console.log("Done loadng USER");
      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }


    getJobSubject(subject_id) {
      this._demoService.getJobSubject(subject_id).subscribe(
        data => { this.subject = data;
          let res = data[0];
          this.subject_number = res.subject_number;
          this.job_number = res.job_id + '.1'; // made up
         // console.log("Done loadng USER");
        },
        error => {
        //  console.error('Error Loading User!');
        //return console.log(error);
        }
      ); }


    createSubjectBilling(model){
      this._demoService.createSubjectBilling(model).subscribe(
        data => {  this.get_latest_subject_billing_id = data; // this is the retuned json upon creation.
         this.toastr.info('Subject Billing Created');
         this.getSubjectBilling(this.subject_id); // refresh the data

        //  this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
        //  this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));

        
        },
        error => {
          // console.log(error(error));
          //return console.log(error);
        }
   );
   }

   updateSubjectBilling(model){
    this._demoService.updateSubjectBilling(model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the list
       // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
      this.toastr.success('Subject Billing Updated');
      this.getSubjectBilling(this.subject_id); // refresh the data
            
                this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
                this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
      },
      error => {
       // console.error('Error saving Event!');
        this.toastr.error('Error saving billing details!');
       return console.log(error);
      }
     // err => console.error(err),
     // () => console.log('done updates')
 );
 }


  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
  };



  
 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


// // :: Parent / Child modal test
// refreshParentdGrid() {
//   alert('parent grid component function.');
//  //this.modalRef.hide();
// this.refreshGrid(); // resets the grid if updated and closed.
// //  this.updateTypeClick = false; // closes the div
// };

refreshSujectInvoicePage(subject_id){
  this.router.navigateByUrl('admin/job/j', {skipLocationChange: true}).then(() =>
                this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));

}


refreshSujectWorkOrderPage(subject_id){
  // this.router.navigateByUrl('admin/job/j', {skipLocationChange: true}).then(() =>
  //               this.router.navigate(['/admin/jobs/subject/cost/' + subject_id + '']));
                this.gfunc.globalJobSubjectCostViewSkipRoute(subject_id);

}


getSubjectInvoices(subject_id) {
  this._demoService.getSubjectInvoices(subject_id).subscribe(
     data => { this.subject_invoices = data;
   let res = data[0];
  // this.subject_invoices = res; // only return the first result and save back the the same variable.
   // do a count if exists
   let newArr = Object(this.subject_invoices);
   this.current_invoice_couunt = Object.keys(newArr).length;

    }, // make the same data call for all
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getSubjectWorkOrders(subject_id) {
  this._demoService.getSubjectWorkOrders(subject_id).subscribe(
     data => { this.subject_work_orders = data;
   let res = data[0];
  // this.subject_invoices = res; // only return the first result and save back the the same variable.
   // do a count if exists
   let newArr = Object(this.subject_work_orders);
   this.current_work_order_couunt = Object.keys(newArr).length;

  // only loads the one result!!!!! hard CDODE....
    // this.getPaymentByInvoiceID(res.invoice_id);
              // if (this.current_work_order_couunt >= 1) {
              //   this.getSpendingsByWorkOrderID(res.work_order_id);
              //   }


    }, // make the same data call for all
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getSpendingsByWorkOrderID(work_order_id){
  this._demoService.getSpendingByWorkOrderID(work_order_id).subscribe(
    (data) => {
      this.spending = data;
      this.spendingModel = this.spending;
      let res = data[0];
      console.log('SpendingModel: ' + JSON.stringify(this.spendingModel));
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


 getSubjectProgress(job_id, file_number){
  this._demoService. getSubjectProgress(job_id, file_number)
  .subscribe(
    res => this.subject_progress = res,
    err => console.error(err.status)
  );
 }





 getInvoiceStatus(invoice_status_id){
  this._demoService.getInvoiceStatus(invoice_status_id).subscribe(
    (data) => {
      this.invoice_status = data;
      let res = data[0];
      this.invoice_status_name = res.invoice_status_name;
      this.invoice_status_var = invoice_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}



getInvoicePaymentStatus(invoice_payment_status_id){
  this._demoService.getInvoicePaymentStatus(invoice_payment_status_id).subscribe(
    (data) => {
      this.invoice_payment_status = data;
      let res = data[0];
      this.invoice_payment_status_name = res.invoice_payment_status_name;
      this.invoice_payment_status_var = invoice_payment_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getInvoiceCommunicationStatus(invoice_communication_status_id){
  this._demoService.getInvoiceCommunicationStatus(invoice_communication_status_id).subscribe(
    (data) => {
      this.invoice_communication_status = data;
      let res = data[0];
      this.invoice_communication_status_name = res.invoice_communication_status_name;
      this.invoice_communication_status_var = invoice_communication_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
    (data) => {
      this.assignedBrandList = data;

    //  this.allEmailRecipients = data;
    },
    (err) => console.error(err),
    // () => console.log('Loaded Assigned Agents Loaded.')
  );
}



myobChecker() {
  this._demoService.myobChecker().subscribe(
     data => { this.myob_checker = data;
      // let res = data[0];
      // this.toastr.success('Myob Connections Active!... functions allowed');
// console.log('Connected: ', JSON.stringify(this.myob_checker));
    },
     err => (
      // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
      console.error(err)
     ),
     // () => console.log('done loading Trace Types')
   );
 }



}
